import React,{useState, useEffect} from 'react';
import { FaQuoteLeft} from 'react-icons/fa';
import { Carousel } from './carousel/components';
import {db} from '../../config/firebase';
import { collection, getDocs } from "firebase/firestore";


export default function Comments(props){

  const [images , setimages] = useState([]);
  const [comentarios, setComentarios] = useState([]);


  useEffect(()=>{
    getDocs(collection(db,'galeria'))
    .then((response)=>{
        let img =[]
        response.forEach((doc)=>{
          img.push(doc.data());
        });
        return img;
    }).then( doc =>{setimages(doc)})
  },[])

  useEffect(()=>{
    getDocs(collection(db,'comentarios'))
    .then((response)=>{
        let comment =[]
        response.forEach((doc)=>{
          comment.push(doc.data());
        });
        return comment;
    }).then( doc =>{setComentarios(doc)})
  },[])

  const isLight = props.tema === 'claro';

  const gallery = images.length > 0 ? (
         <Carousel time={5000}>
         { 
           images.map((image, index) => 
             <div
             className="w-full overflow-hidden rounded-xl"
             key={index}>
               <img src={image.url} alt={image.alt || image.titulo || 'Galería Apriori'} className="w-full object-cover"/>
               <p className="text-center font-regular leading-7 p-4 w-full bg-fondo text-white">{image.titulo}</p>
             </div>
           )
         }
       </Carousel>
  ) : (
    <div className={`w-full h-64 rounded-xl flex items-center justify-center ${isLight ? 'bg-gray-100 text-gray-400' : 'bg-secundary text-gray-400'}`}>Galería en preparación</div>
  );

  const testimonials = comentarios.length > 0 ? (
        <Carousel time={5000}>
        { 
          comentarios.map((image, index) => 
            <div 
            className="flex flex-col md:flex-row justify-start items-start w-full p-4 md:p-6"
            key={index}>
              <FaQuoteLeft className="text-primary text-2xl mb-3 md:mb-0 md:mt-1"/>
              <div className="ml-0 md:ml-5 text-center md:text-left">
                  <p className="font-medium text-lg md:text-xl leading-8">{image.message}</p>
                  <p className="font-semibold pt-4">{image.autor}</p>
                  <p className="text-primary font-bold text-sm">{image.cargo}</p>
              </div>
            </div>
          )
        }
      </Carousel>
  ) : (
    <p className="text-gray-500 p-4">Pronto verás testimonios de quienes ya se prepararon con Apriori.</p>
  );

  return(
    props.tema === 'claro'?
    <>
     <div className = "p-6 md:p-12 bg-white">
     <div className="landing-wrap flex flex-col md:flex-row justify-between items-start">
        <div  className="flex flex-row justify-center w-full md:w-5/12 mb-8 md:mb-0">
         {gallery}
        </div>
        <div className="w-full md:w-6/12 p-2 md:p-4 ">
        <p className="text-primary text-sm font-bold uppercase tracking-widest">Testimonios</p>
      <h2 className="font-bold text-2xl md:text-4xl leading-tight my-4 text-fondo">Lo que dicen nuestros clientes</h2>
      
        {testimonials}
        </div>
      </div>
     </div>
    </>:
    <>
    <div className = "p-6 md:p-12 bg-fondo">
     <div className="landing-wrap">
     <p className="text-primary text-sm font-bold uppercase tracking-widest text-center md:text-left">Testimonios</p>
     <h2 className="font-bold text-2xl md:text-4xl leading-tight my-4 text-white text-center md:text-left">Lo que dicen nuestros clientes</h2>
     <div className="flex flex-col md:flex-row justify-between items-start">
       <div  className="flex flex-row justify-center w-full md:w-5/12 mb-8 md:mb-0">
         {gallery}
       </div>
       <div className="w-full md:w-6/12 text-white">
       {testimonials}
       </div>
     </div>
     </div>
    </div>
   </>
    );
};
